export const SubscriptionHelper = {
  isAlive: (subscriptionStatus: string) => {
    if (!subscriptionStatus) return true;
    return ["pending", "authorized"].includes(subscriptionStatus);
  }
};
